module.exports = {
      id: "shorts-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#shorts",
      toString: function () {
        return this.url;
      }
    }